import { render, staticRenderFns } from "./AdvOrderTransporters.vue?vue&type=template&id=57570e52&"
import script from "./AdvOrderTransporters.vue?vue&type=script&lang=js&"
export * from "./AdvOrderTransporters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports